import { render, staticRenderFns } from "./ConsentForms.vue?vue&type=template&id=514d8481&"
import script from "./ConsentForms.vue?vue&type=script&lang=js&"
export * from "./ConsentForms.vue?vue&type=script&lang=js&"
import style0 from "./ConsentForms.vue?vue&type=style&index=0&id=514d8481&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports